import clsx from "clsx"

import { Popover } from "@molecules"

import useObjectsView from "@organisms/ObjectsView/ObjectsView.context"
import ScheduleHorizonControl from "@organisms/ViewMenu/ScheduleHorizonControl/ScheduleHorizonControl"

import ColumnOrdering from "./ColumnOrdering/ColumnOrdering"
import SortingControl from "./SortingControl/SortingControl"
import styles from "./TableViewMenu.module.scss"

export const TABLE_VIEW_MENU_COMPONENT_IDS = ["main"]

export default function TableViewMenu() {
    const { isScheduleHorizonAvailable } = useObjectsView()

    return (
        <Popover.View componentId="main">
            <Popover.Section animationType="slide">
                <Popover.Body>
                    {isScheduleHorizonAvailable && (
                        <div className={styles.scheduleHorizonSection}>
                            <div className={styles.sectionTitle}>Schedule horizon</div>
                            <ScheduleHorizonControl isVisible={true} />
                        </div>
                    )}
                    <div className={styles.sortbySection}>
                        <div className={styles.sectionTitle}>Sort by</div>
                        <SortingControl isVisible={true} />
                    </div>
                    <div className={clsx(styles.sectionTitle, styles.columnTitle)}>Columns</div>
                    <ColumnOrdering isVisible={true} />
                </Popover.Body>
            </Popover.Section>
        </Popover.View>
    )
}
